/* eslint-disable quote-props */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable camelcase */
/* eslint-disable no-lonely-if */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable radix */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/forbid-foreign-prop-types */
/* eslint-disable no-shadow */
/* eslint-disable no-alert */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/button-has-type */

import React, {
  useState, useEffect, useContext, useRef,
} from 'react';
import { useSnackbar } from 'notistack';
import {
  useElements,
  CardCvcElement,
  useStripe,
  CardNumberElement,
  CardExpiryElement,
} from '@stripe/react-stripe-js';
import * as Sentry from '@sentry/react';
import HelpIcon from '@material-ui/icons/Help';
import {
  FormControl,
  Tooltip,
  Checkbox,
  RadioGroup,
  IconButton,
  CircularProgress,
} from '@material-ui/core';
import { v4 as uuidv4 } from 'uuid';
import {
  Link, useHistory, useLocation, Redirect,
} from 'react-router-dom';

import PATH from 'routes/path';
import { AuthContext } from 'providers/AuthProvider';

import { getCustomers, updateCustomer } from 'services/api/customers';
import { purchaseCase, getCaseById } from 'services/api/cases';
import { formatCurrency } from 'services/helpers/string';
import { createEventTracking } from 'services/api/tracking';

import RadioButton from 'components/RadioButton';
import Loading from 'components/Loading';
import { InputText } from 'components/InputText';
import { Button } from 'components/Button';
import { ALERT_TYPE } from 'components/Alert';
import SnackMessage, { OPTIONS } from 'components/SnackMessage';

import { COLOR } from 'assets/styles/colors';
import flagCard from 'assets/icons/flag-card.svg';

import { Error } from '@material-ui/icons';
import { logPurchaseGA } from 'services/helpers/analytics';
import {
  FormWrapper,
  Resume,
  Container,
  Cards,
  GroupInputsCard,
  BoxHeader,
  BoxOptin,
  BoxCoupon,
  MessageCoupon,
  KitWrapper,
  BuyResume,
  ResumeLoading,
} from './styles';
import HelpModal from './HelpModal';
import PaymentModal from './PaymentModal';
import PixSection from './PixSection';
import HelpCheckout from './HelpCheckout';

// Registra conversão gtag
function logPurchaseGtag(value, option) {
  gtag('event', 'conversion', {
    send_to: 'AW-945060728/smsFCJHKsdQCEPj20cID',
    transaction_id: uuidv4(),
    currency: 'BRL',
    affiliation: 'LOIT FGTS',
    option,
    value,
  });
}

// FORM. DE PAGAMENTO
export const CheckoutForm = () => {
  const history = useHistory();
  const params = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const { currentUser } = useContext(AuthContext);
  const [loadingPaymentPrice, setLoadingPaymentPrice] = useState(false);
  const [customer, setCustomer] = useState({});
  const [pagseguro, setPagseguro] = useState({});
  const [cardName, setCardName] = useState('');
  const [codeCoupon, setCodeCoupon] = useState('');
  const [clientSecret, setClientSecret] = useState('');
  const [autoCoupon, setAutoCoupon] = useState(false);
  const [price, setPrice] = useState(0);
  const [newKitPrice, setNewKitPrice] = useState(0);
  const [couponPrice, setCouponPrice] = useState(0);
  const [checked, setChecked] = useState(false);
  const [checkedAlt, setCheckedAlt] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openHelpCheckout, setOpenHelpCheckout] = useState(false);
  const [alreadyPaid, setAlreadyPaid] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [checkedField, setCheckedField] = useState({
    cardNumber: {
      error: false,
      complete: false,
    },
    cardExpiry: {
      error: false,
      complete: false,
    },
    cardCvc: {
      error: false,
      complete: false,
    },
  });
  const [openHelp, setOpenHelp] = useState(false);
  const [coupon, setCoupon] = useState(false);
  const [loadingCoupon, setLoadingCoupon] = useState(false);
  const [loadingPagseguro, setLoadingPagseguro] = useState(false);
  const [value, setValue] = useState('pix');
  const [kit, setKit] = useState('basico');
  const [pix, setPix] = useState({
    qrcode: '',
    qrimage: '',
  });
  const [pixLoading, setPixLoading] = useState(false);
  const [isPagSeguro, setIsPagseguro] = useState(false);

  const timer = useRef(null);

  const handleChange = (event) => setValue(event.target.value);

  const handleChangeKit = (event) => setKit(event.target.value);

  const showHelp = () => {
    window.Intercom('trackEvent', 'LOIT FGTS pagamento ajuda');
    setOpenHelp(true);
  };

  const closeHelp = () => setOpenHelp(false);

  const formatPrice = (priceFormat, purchase) => {
    if (purchase) {
      return parseFloat(
        `${priceFormat
          .toString()
          .substring(0, priceFormat.toString().length - 2)}.${priceFormat
          .toString()
          .substring(
            priceFormat.toString().length - 2,
            priceFormat.toString().length,
          )}`,
      );
    }
    return parseFloat(
      `${priceFormat
        .toString()
        .substring(0, priceFormat.toString().length - 2)}.${priceFormat
        .toString()
        .substring(
          priceFormat.toString().length - 2,
          priceFormat.toString().length,
        )}`,
    ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  };

  const handlePushDataLayer = async (transactionPrice) => {
    try {
      window.dataLayer.push({
        id_transacao: params.state.idCase,
        valor_transacao: transactionPrice,
      });
    } catch (err) {
      console.error(err);
    }
  };

  // Carrega dodao de Cartão de crédito
  const getClientSecret = async (remove) => {
    if (!remove) setLoadingCoupon(true);
    setLoadingPaymentPrice(true);

    const payload = {
      provider: 'stripe',
      promo_code: codeCoupon,
      payment_method: 'credit_card_transparent',
    };

    if (!payload.promo_code || remove) {
      setCodeCoupon('');
      setCouponPrice(0);
      setCoupon(false);
      delete payload.promo_code;
    }

    try {
      const { data } = await purchaseCase(params.state.idCase, payload);
      handlePushDataLayer(data.payment_price);

      setAutoCoupon(!codeCoupon && data.original_price !== data.payment_price);

      setClientSecret(data.checkout_session_id);
      setPrice(data.original_price);
      if (data.payment_price) {
        setCouponPrice(data.original_price - data.payment_price);
      }
    } catch (error) {
      const { response } = error;
      if (
        response.data.error.detail[0] === 'Cupom invalido'
        || response.data.error.detail[0] === 'Cupom já foi utilizado'
      ) {
        setCodeCoupon('');
        setCouponPrice(0);

        enqueueSnackbar(response.data.error.detail[0], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      } else {
        setAlreadyPaid(true);
        setOpen(true);
        setClientSecret('');
      }
    }
    setLoadingPage(false);
    setLoadingCoupon(false);
    setLoadingPaymentPrice(false);
  };

  // Chamada para gerar os códigos QR
  const getPixPayment = async (remove = false) => {
    setPixLoading(true);
    setLoadingPaymentPrice(true);

    if (!remove) setLoadingCoupon(true);

    const payload = {
      provider: 'pix',
      promo_code: codeCoupon,
      payment_method: 'pix',
    };

    if (!payload.promo_code || remove) {
      setCodeCoupon('');
      setCouponPrice(0);
      setCoupon(false);
      delete payload.promo_code;
    }

    try {
      const { data } = await purchaseCase(params.state.idCase, payload);
      handlePushDataLayer(data.payment_price);

      const { qrcode, imagemQrcode } = data.checkout_session_id;

      setAutoCoupon(!codeCoupon && data.original_price !== data.payment_price);

      setPix({
        qrcode,
        qrimage: imagemQrcode,
      });

      setPrice(data.original_price);
      setCouponPrice(data.original_price - data.payment_price);
    } catch (error) {
      const { response } = error;
      if (response && response.data.error) {
        // Caso já pago
        if (response.data.error.detail[0] === 'Case already paid') {
          const { data } = await getCaseById(params.state.idCase);

          if (data.payment_method === 'pagseguro') {
            setIsPagseguro(true);
          }

          if (window.localStorage.getItem('checkout_pagseguro')) {
            logPurchaseGA(
              'purchase',
              newKitPrice || 294,
              'PagSeguro (Atermação)',
            );
            window.localStorage.removeItem('checkout_pagseguro');
            history.push(PATH.ATERMACAO);
          } else {
            setAlreadyPaid(true);
            setOpen(true);
          }
        } else if (
          response.data.error.detail[0] === 'Cupom invalido'
          || response.data.error.detail[0] === 'Cupom já foi utilizado'
        ) {
          setCodeCoupon('');
          setCouponPrice(0);

          enqueueSnackbar(response.data.error.detail[0], {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                message={message}
                variant={ALERT_TYPE.ERROR}
              />
            ),
          });
          // Outro tipo de erro
        } else {
          enqueueSnackbar(response.data.error.detail[0], {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                message={message}
                variant={ALERT_TYPE.ERROR}
              />
            ),
          });
        }
        // Erro genérico
      } else {
        enqueueSnackbar(
          'Desculpe, ocorreu um erro ao carregar os dados de pagamento.',
          {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                message={message}
                variant={ALERT_TYPE.ERROR}
              />
            ),
          },
        );
      }
    } finally {
      setLoadingPage(false);
      setPixLoading(false);
      setLoadingCoupon(false);
      setLoadingPaymentPrice(false);
    }
  };

  // Carrega dados de pagamento do PagSeguro
  const loadPagSeguroPayment = async () => {
    const payload = {
      promo_code: codeCoupon,
      payment_method: 'pagseguro',
      product_name: 'LOIT-FGTS-ATERMACAO',
      success_url: `${process.env.REACT_APP_APP_URL}${PATH.PAYMENT}`,
      provider: 'pagseguro',
    };

    setLoadingPaymentPrice(true);
    setLoadingPagseguro(true);

    try {
      const { data } = await purchaseCase(params.state.idCase, payload);
      handlePushDataLayer(data.payment_price);

      setAutoCoupon(!codeCoupon);
      setPagseguro(data);
      setNewKitPrice(data.original_price);
      setCouponPrice(data.original_price - data.payment_price);
    } catch ({ response }) {
      // console.error(err);
      if (
        response.data.error.detail[0] === 'Cupom invalido'
        || response.data.error.detail[0] === 'Cupom já foi utilizado'
      ) {
        setCodeCoupon('');
        setCouponPrice(0);

        enqueueSnackbar(response.data.error.detail[0], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      } else {
        enqueueSnackbar(
          'Desculpe, ocourreu um erro ao gerar o pagamento para o Kit + Atermação.',
          {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                message={message}
                variant={ALERT_TYPE.ERROR}
              />
            ),
          },
        );
      }
    } finally {
      setLoadingPagseguro(false);
      setLoadingPaymentPrice(false);
    }
  };

  const setCouponValues = (remove) => {
    if (kit === 'atermacao') {
      loadPagSeguroPayment();
    } else if (value === 'pix') {
      getPixPayment(remove);
    } else if (value) {
      getClientSecret(remove);
    }
  };

  const loadCustomer = async () => {
    try {
      const { data } = await getCustomers();
      setCustomer(data[0]);

      const { coupon } = data[0].meta_data;

      // Inicializa pagamento por pix ou cartão de crédito
      if (value === 'pix') {
        getPixPayment(false);
      } else {
        getClientSecret(false);
      }

      if (coupon) {
        setCoupon(true);
        setCodeCoupon(coupon);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Carrega dados do caso
  const loadCaseData = async () => {
    try {
      const { data } = await getCaseById(params.state.idCase);
      if (data.payment_status === 'paid') {
        setAlreadyPaid(true);
        setOpen(true);

        const payload = {
          ...customer,
          meta_data: {
            ...customer.meta_data,
            step:
              customer.meta_data.step && customer.meta_data.step > 3
                ? customer.meta_data.step
                : 3,
            idCase: params.state.idCase,
            paidOut: true,
            newFgts: false,
            method_payment: 'pix',
          },
        };

        await updateCustomer(customer.id, payload);

        if (value === 'pix') {
          const totalValue = formatPrice(price - couponPrice, true);

          // Registra uma transação no Google Analytics (Pix)
          logPurchaseGA('purchase', totalValue, 'Pix');

          logPurchaseGtag(totalValue, 'Pix');

          fbq('track', 'Purchase', { currency: 'BRL', value: totalValue });

          window.Intercom('trackEvent', 'LOIT FGTS compra kit_pix_gn');
        }

        if (window.localStorage.getItem('checkout_pagseguro')) {
          window.localStorage.removeItem('checkout_pagseguro');
        }
        if (timer.current) clearInterval(timer.current);
      }
    } catch (error) {
      if (timer.current) clearInterval(timer.current);
      enqueueSnackbar(
        'Desculpe, ocorreu um erro ao carregar os dados do caso.',
        {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        },
      );
      Sentry.captureException(new Error('failed to fetch case'));
    }
  };

  useEffect(() => {
    const onComponentMount = async () => {
      window.Intercom('trackEvent', 'LOIT FGTS pagamento');
      fbq('track', 'InitiateCheckout');
      createEventTracking('120 - comprar');

      if (window.localStorage.getItem('checkout_pagseguro')) {
        setOpenHelpCheckout(true);
      }

      await loadCustomer();
    };

    onComponentMount();
  }, []);

  useEffect(() => {
    if (value === 'pix' && checked) {
      loadCaseData();
      timer.current = setInterval(() => loadCaseData(), 10000); // 10s
    } else if (value === 'credit') {
      getClientSecret(false);
      if (timer.current) clearInterval(timer.current);
    }

    return () => clearInterval(timer.current);
  }, [value, checked]);

  useEffect(() => {
    const handleLoadPayment = async () => {
      if (kit === 'atermacao') {
        await loadPagSeguroPayment();
      } else {
        await loadCustomer();
      }
    };

    handleLoadPayment();
  }, [kit]);

  const validateFields = () => {
    if (
      cardName
      && !checkedField.cardNumber.error
      && checkedField.cardNumber.complete
      && !checkedField.cardExpiry.error
      && checkedField.cardExpiry.complete
      && !checkedField.cardCvc.error
      && checkedField.cardCvc.complete
      && checked
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  useEffect(() => {
    validateFields();
  }, [cardName, checkedField, checked]);

  const handleCheck = (e) => {
    setChecked(e.target.checked);
  };

  const handleCheckAlt = (e) => {
    setCheckedAlt(e.target.checked);
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    window.Intercom('trackEvent', 'LOIT FGTS envio pgto');
    createEventTracking('130 - meio de pagamento');
    setLoading(true);

    try {
      const confirmCardPayment = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardNumberElement),
          billing_details: {
            name: cardName,
          },
        },
      });
      if (confirmCardPayment.error) {
        console.log(confirmCardPayment.error);
        Sentry.captureException(
          new Error('failed to confirm payment'),
          (scope) => {
            scope.clear();
            scope.setContext('character', {
              name: currentUser.displayName && currentUser.displayName,
              phone: currentUser.phoneNumber && currentUser.phoneNumber,
              email: currentUser.email && currentUser.email,
            });
            scope.setContext('response_api', {
              message: confirmCardPayment.error.message,
              type: confirmCardPayment.error.type,
              doc_url: confirmCardPayment.error.doc_url,
              code: confirmCardPayment.error.code,
            });
            return scope;
          },
        );
        setOpen(true);
      } else {
        await createEventTracking('140 - compra efetuada');

        const totalValue = formatPrice(price - couponPrice, true);

        window.Intercom('trackEvent', 'LOIT FGTS compra kit_cc_stripe');

        fbq('track', 'Purchase', { currency: 'BRL', value: totalValue });

        // Registra uma transação no Google Analytics (Credit)
        logPurchaseGA('purchase', totalValue, 'Credit');

        logPurchaseGtag(totalValue, 'Credit');

        const payload = {
          ...customer,
          meta_data: {
            ...customer.meta_data,
            step:
              customer.meta_data.step && customer.meta_data.step > 3
                ? customer.meta_data.step
                : 3,
            idCase: params.state.idCase,
            paidOut: true,
            newFgts: false,
            method_payment: 'credit_card',
          },
        };

        await updateCustomer(customer.id, payload);
        // Redirect to Docs
        history.push({
          pathname: PATH.DOCUMENTS,
          state: {
            idCase: params.state.idCase,
          },
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(true);
    }

    setLoading(false);
  };

  const alertTermCheck = () => {
    enqueueSnackbar('Assinale o campo abaixo para continuar a compra', {
      ...OPTIONS,
      content: (key, message) => (
        <SnackMessage id={key} message={message} variant={ALERT_TYPE.ERROR} />
      ),
    });
  };

  const goToCheckout = () => {
    const totalValue = newKitPrice; // R$ 294,00

    logPurchaseGA('checkout', totalValue, 'External checkout (PagSeguro)');

    // Evento gtag (Enoma)
    gtag('event', 'External checkout (PagSeguro)', {
      payment_method: 'credit',
      value: totalValue,
    });

    // TODO: Add intercom event
    // window.Intercom('trackEvent', 'LOIT FGTS compra atermacao_ps');
    window.localStorage.setItem('checkout_pagseguro', 'true');
    setOpenHelpCheckout(true);
    window.open(pagseguro.checkout_session_id, '_blank').focus();
  };

  // Retorna fluxo de pagamento (CC/Pix)
  const getPaymentMethodSection = () => (value !== 'pix' ? (
  // CARTÃO DE CRÉDITO
    <Cards loadingPage={loadingPage}>
      <p style={{ padding: couponPrice > 0 ? 0 : '32px 0 0' }} />
      <img
        src={flagCard}
        alt={`${flagCard} icon`}
        style={{ display: 'block', margin: '32px auto 32px' }}
      />
      <form id="payment-form" onSubmit={handleSubmit}>
        <InputText
          name="cardName"
          label="Nome impresso no cartão"
          value={cardName}
          autoComplete="cc-name"
          onChange={(value) => setCardName(value.cardName)}
        />
        <InputText
          name="cardNumber"
          label="Número do cartão"
          inputComponent={CardNumberElement}
          onChange={(value) => {
            setCheckedField({
              ...checkedField,
              cardNumber: {
                error: !!value.cardNumber.error,
                complete: !!value.cardNumber.complete,
              },
            });
          }}
        />
        <GroupInputsCard>
          <InputText
            name="cardExpiry"
            label="Validade"
            inputComponent={CardExpiryElement}
            onChange={(value) => {
              setCheckedField({
                ...checkedField,
                cardExpiry: {
                  error: !!value.cardExpiry.error,
                  complete: !!value.cardExpiry.complete,
                },
              });
            }}
            width={49}
          />
          <InputText
            name="cardCvc"
            label="CVV"
            inputComponent={CardCvcElement}
            onChange={(value) => {
              setCheckedField({
                ...checkedField,
                cardCvc: {
                  error: !!value.cardCvc.error,
                  complete: !!value.cardCvc.complete,
                },
              });
            }}
            width={49}
          />
        </GroupInputsCard>
        <BoxOptin>
          <Checkbox
            size="small"
            id="disclaimer"
            checked={checked}
            onChange={handleCheck}
          />
          <label htmlFor="disclaimer" style={{ cursor: 'pointer' }}>
            Concordo que os meus extratos estão corretos e que{' '}
            <strong>NÃO</strong> será possível alterá-los após a compra do
            KIT.
          </label>
        </BoxOptin>
        <Button
          id="submit"
          onClick={disabled ? () => alertTermCheck() : (e) => handleSubmit(e)}
          disabledAlert={disabled}
          style={{
            width: '100%',
            maxWidth: '324px',
          }}
          loading={loading}
        >
          Comprar: {price ? formatPrice(price - couponPrice) : 'R$ 00,00'}
        </Button>
        <Link to="home" style={{ textDecoration: 'none' }}>
          <Button
            variant="outlined"
            style={{ width: '324px' }}
            className="unset"
          >
            Voltar
          </Button>
        </Link>
      </form>
    </Cards>
  ) : (
  // PIX
    <PixSection
      pix={pix}
      loading={pixLoading}
      checked={checked}
      handleCheck={handleCheck}
      reload={getPixPayment}
    />
  ));

  if (!params.state) {
    return <Redirect to={PATH.HOME} />;
  }

  if (loadingPage) return <Loading bg="white" />;

  return (
    <Container>
      <PaymentModal
        open={open}
        onClose={setOpen}
        isPagSeguro={isPagSeguro}
        alreadyPaid={alreadyPaid}
        idCase={params.state.idCase}
        price={price}
      />
      <HelpCheckout
        open={openHelpCheckout}
        onClose={() => setOpenHelpCheckout(false)}
      />
      <BoxHeader>
        <h1>Contratar KIT ou Atermação</h1>
        {/* ICONE DE AJUDA */}
        <Tooltip title="Informação sobre o pagamento" arrow>
          <IconButton
            size="small"
            color="secondary"
            onClick={showHelp}
            disabled={openHelp}
          >
            Ajuda
            <HelpIcon />
          </IconButton>
        </Tooltip>
        {/* MODAL DE AJUDA */}
        {openHelp && <HelpModal open={openHelp} onClose={closeHelp} />}
        <h2>
          Valor calculado para correção <br />
          do seu saldo do FGTS:
          {localStorage.getItem('calculated_value') && (
            <span>
              {formatCurrency(
                parseFloat(localStorage.getItem('calculated_value')),
              )}
            </span>
          )}
        </h2>
      </BoxHeader>
      {/* SELEÇÃO DO TIPO DE KIT */}
      <h3>Selecione o KIT desejado:</h3>
      <FormWrapper>
        <FormControl component="fieldset">
          <RadioGroup
            name="kit"
            value={kit}
            aria-label="Selecione o KIT desejado"
            onChange={handleChangeKit}
          >
            <RadioButton
              value="basico"
              label={`Petição + Planilha (${formatPrice(price)})`}
            />
            {kit === 'basico' && (
              <KitWrapper>
                <p>
                  A <strong>petição inicial</strong> contém os seus dados
                  pessoais e demonstra o seu direito, com fundamentos jurídicos.
                </p>

                <p>
                  A <strong>planilha de cálculo</strong> apresenta uma
                  estimativa do quanto seu FGTS perdeu valor de compra com o
                  passar dos anos.
                </p>

                <p>
                  Esse conjunto permitirá que você entre sozinho com o processo
                  na Justiça.
                </p>
              </KitWrapper>
            )}
            <RadioButton
              value="atermacao"
              label="Petição + Planilha + Atermação (R$ 490,00)"
            />
            {kit === 'atermacao' && (
              <KitWrapper>
                <p>
                  O <strong>serviço de atermação</strong> contempla a Petição e
                  a Planilha do KIT básico mais o serviço da nossa equipe que
                  fará o protocolo do seu processo no JEF da sua região.
                  Conforme sua região, este procedimento poderá demandar a sua
                  presença física para confirmação no Juizado -{' '}
                  <a
                    href="https://ajuda.tikal.tech/pt-BR/articles/5243893-loit-fgts-servico-de-atermacao"
                    target="_blank"
                    rel="noreferrer"
                  >
                    saiba mais neste artigo da central de ajuda
                  </a>
                  .
                </p>
              </KitWrapper>
            )}
          </RadioGroup>
        </FormControl>
      </FormWrapper>

      <BuyResume>
        {loadingPaymentPrice ? (
          <ResumeLoading>
            <CircularProgress style={{ color: '#2B938A' }} />
          </ResumeLoading>
        ) : (
          <>
            <h3>Resumo da compra:</h3>
            <Resume>
              <p>
                Kit:{' '}
                {kit === 'basico'
                  ? 'Petição e cálculo'
                  : 'Petição, cálculo e atermação'}
                <span>
                  {/* {kit === 'basico' ? formatPrice(price) : 'R$ 294,00'} */}
                  {kit === 'basico'
                    ? formatPrice(price)
                    : formatPrice(newKitPrice)}
                </span>
              </p>
            </Resume>

            <Resume>
              {couponPrice > 0 ? (
                <>
                  <p
                    style={{
                      borderBottom: `1px solid ${COLOR.GREY_3}`,
                      justifyContent: 'flex-start',
                      padding: '10px 0 14px 0',
                    }}
                  >
                    Cupom aplicado: {!autoCoupon ? codeCoupon : ''}{' '}
                    {!autoCoupon && (
                      <label onClick={() => setCouponValues(true)}>
                        Remover
                      </label>
                    )}
                    <span style={{ marginLeft: 'auto' }}>
                      {`- ${formatPrice(couponPrice)}`}
                    </span>
                  </p>
                  <p
                    style={{
                      justifyContent: 'flex-end',
                      padding: '14px 0',
                      fontWeight: 500,
                      borderBottom: '1px solid #C8CBD4',
                    }}
                  >
                    Total:{' '}
                    {kit === 'atermacao'
                      ? formatPrice(newKitPrice - couponPrice)
                      : formatPrice(price - couponPrice)}
                  </p>
                </>
              ) : (
                <div
                  style={{
                    padding: '10px 0',
                    borderBottom: '1px solid #C8CBD4',
                  }}
                />
              )}
            </Resume>
          </>
        )}
      </BuyResume>

      {/* SECÃO DE CUPOM */}
      {
        <BoxCoupon coupon={coupon}>
          <p
            onClick={() => {
              if (autoCoupon || couponPrice === 0) {
                setCoupon(!coupon);
                setCodeCoupon('');
              }
            }}
          >
            Possui cupom?
          </p>
          <div>
            <InputText
              name="codeCoupon"
              label="Digite aqui o seu cupom"
              value={codeCoupon}
              disabled={autoCoupon ? false : couponPrice > 0}
              onChange={(value) => setCodeCoupon(value.codeCoupon)}
            />
            <Button
              onClick={() => setCouponValues(false)}
              disabled={autoCoupon ? false : couponPrice > 0}
              style={{
                width: '100%',
                maxWidth: '324px',
              }}
              loading={loadingCoupon}
            >
              Usar
            </Button>
          </div>
          {!autoCoupon && couponPrice > 0 && (
            <MessageCoupon>
              Cupom aplicado! Verifique no Resumo da compra
            </MessageCoupon>
          )}
        </BoxCoupon>
      }
      {kit === 'basico' ? (
        <>
          <FormWrapper>
            <FormControl component="fieldset">
              <legend>Escolha a forma de pagamento:</legend>
              <RadioGroup
                name="payment"
                value={value}
                aria-label="payment"
                onChange={handleChange}
              >
                <RadioButton value="pix" label="Pagamento via PIX" />
                <RadioButton value="credit" label="Cartão de crédito" />
              </RadioGroup>
            </FormControl>
          </FormWrapper>
          {getPaymentMethodSection()}
        </>
      ) : (
        <>
          <BoxOptin>
            <Checkbox
              size="small"
              id="disclaimer"
              checked={checkedAlt}
              onChange={handleCheckAlt}
            />
            <label htmlFor="disclaimer" style={{ cursor: 'pointer' }}>
              Concordo que os meus extratos estão corretos e que{' '}
              <strong>NÃO</strong> será possível alterá-los após a compra do
              KIT.
            </label>
          </BoxOptin>
          <Button
            onClick={goToCheckout}
            style={{ width: '100%' }}
            disabled={!checkedAlt || loadingPagseguro}
          >
            Continuar para pedido de revisão
          </Button>
          <Link to="home">
            <Button variant="outlined" className="unset">
              Voltar
            </Button>
          </Link>
        </>
      )}
    </Container>
  );
};
